module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/scale-edit/scale-edit.component.css
// module id = ./src/app/admin/scale-edit/scale-edit.component.css
// module chunks = main